import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import ErpTemplate from '../../components/ErpTemplate';
import { FinField, FinInput, FinNumber } from '../../components/FinField';
import ReactSelect from '../../components/ReactSelect';
import api from '../../services/api';
import { buscarCep, extract } from '../../util/util';
import '../../css/financeiro-parcela-pagar.css';

const OPCOES_SITUACAO = [
    { value: 'ativo', label: 'Ativo' },
    { value: 'inativo', label: 'Inativo' },
];

export default function CadastroEmpresa({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const history = useHistory();
    const [tabState, setTabState] = useState('geral');
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(!!id);

    const preencherCep = (cep, dadosAtuais) => {
        buscarCep(cep).then((resposta) => {
            if (resposta.erro) {
                return;
            }
            setDados({
                ...dadosAtuais,
                enderecobairro: resposta.bairro,
                enderecocomplemento: resposta.complemento,
                enderecologradouro: resposta.logradouro,
                enderecopais: '30',
                nomeEnderecopais: 'Brasil',
                enderecomunicipio: resposta.ibge,
                nomeEnderecomunicipio: resposta.localidade
            });
        });
    };

    const buscar = () => {
        setIsLoading(true);
        if (!id) {
            setIsLoading(false);
            return;
        }
        api({
            method: 'get',
            action: `/participante/${id}`,
            token,
        }).then((response) => {
            const dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: ['enderecopais', 'enderecomunicipio']
            });
            delete dadosRecebidos.tipoparticipante;
            setDados(dadosRecebidos);
        }).catch(() => { }).finally(() => setIsLoading(false));
    };

    const salvar = () => {
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);

        const payload = { ...dados };
        delete payload.banco;

        if (id) {
            delete payload.tipoparticipante;
            delete payload.aereomunicipioembarque;
        }

        const requisicao = id
            ? { method: 'put', action: `/participante/${id}`, data: payload }
            : { method: 'post', action: '/participante', data: { ...payload, tipoCadastro: 'empresa' } };

        api({
            ...requisicao,
            token,
        })
            .then(() => {
                toast.success('Dados salvos com sucesso!');
                history.push('/empresa');
            })
            .catch((error) => {
                toast.error('Erro ao salvar: ' + (error.response?.data?.error ?? error.message ?? ''));
            })
            .finally(() => setIsSubmitting(false));
    };

    useEffect(() => {
        document.querySelector('#nome')?.focus();
        buscar();
        // eslint-disable-next-line
    }, []);

    return (
        <ErpTemplate processando={isLoading}>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Empresa</h1>
                        <p className="fin-pp__subtitle">{dados.nomefantasia || dados.nome || 'Nova empresa'}</p>
                    </div>
                    <div className="fin-pp__actions">
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill" onClick={salvar} disabled={isSubmitting}>
                            {isSubmitting ? 'Salvando...' : 'Salvar'}
                        </button>
                    </div>
                </div>

                <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                    <div className="fin-pp__tabs mb-3">
                        {[
                            { key: 'geral', label: 'Geral' },
                            { key: 'endereco', label: 'Endereço' },
                        ].map((item) => (
                            <button
                                key={item.key}
                                type="button"
                                className={'fin-pp__tab' + (tabState === item.key ? ' is-active' : '')}
                                onClick={() => setTabState(item.key)}
                            >
                                {item.label}
                            </button>
                        ))}
                    </div>

                    {tabState === 'geral' && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-title">Dados gerais</span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Situação">
                                    <ReactSelect
                                        value={dados.situacaoRegistro ? OPCOES_SITUACAO.find((item) => item.value === dados.situacaoRegistro) ?? null : null}
                                        onChange={(e) => setDados({ ...dados, situacaoRegistro: e?.value ?? '', nomeSituacaoRegistro: e?.label ?? '' })}
                                        options={OPCOES_SITUACAO}
                                    />
                                </FinField>
                                <FinField label="Nome" full>
                                    <FinInput id="nome" value={dados.nome ?? ''} onChange={(e) => setDados({ ...dados, nome: e.target.value })} />
                                </FinField>
                                <FinField label="Nome Fantasia">
                                    <FinInput value={dados.nomefantasia ?? ''} onChange={(e) => setDados({ ...dados, nomefantasia: e.target.value })} />
                                </FinField>
                                <FinField label="CNPJ">
                                    <FinInput value={dados.cnpj ?? ''} onChange={(e) => setDados({ ...dados, cnpj: e.target.value })} />
                                </FinField>
                                <FinField label="Alíquota Impostos">
                                    <FinNumber
                                        value={dados.issaliquota || ''}
                                        onValueChange={(values) => setDados({ ...dados, issaliquota: values.value })}
                                    />
                                </FinField>
                            </div>
                        </div>
                    )}

                    {tabState === 'endereco' && (
                        <div className="fin-pp__card" style={{ padding: '12px 16px', marginBottom: 16 }}>
                            <div className="fin-pp__cphead">
                                <span className="fin-pp__cphead-title">Endereço</span>
                            </div>
                            <div className="fin-pp__filters">
                                <FinField label="Rua / Logradouro" grow>
                                    <FinInput value={dados.enderecologradouro ?? ''} onChange={(e) => setDados({ ...dados, enderecologradouro: e.target.value })} />
                                </FinField>
                                <FinField label="Número">
                                    <FinInput value={dados.endereconumero ?? ''} onChange={(e) => setDados({ ...dados, endereconumero: e.target.value })} />
                                </FinField>
                                <FinField label="Complemento" grow>
                                    <FinInput value={dados.enderecocomplemento ?? ''} onChange={(e) => setDados({ ...dados, enderecocomplemento: e.target.value })} />
                                </FinField>
                                <FinField label="CEP">
                                    <FinInput
                                        value={dados.enderecocep ?? ''}
                                        onChange={(e) => {
                                            const proximo = { ...dados, enderecocep: e.target.value };
                                            setDados(proximo);
                                            preencherCep(e.target.value, proximo);
                                        }}
                                    />
                                </FinField>
                                <FinField label="Bairro">
                                    <FinInput value={dados.enderecobairro ?? ''} onChange={(e) => setDados({ ...dados, enderecobairro: e.target.value })} />
                                </FinField>
                                <FinField label="Cidade">
                                    <ReactSelect
                                        value={dados.enderecomunicipio ? { value: dados.enderecomunicipio, label: dados.nomeEnderecomunicipio } : null}
                                        onChange={(e) => setDados({ ...dados, enderecomunicipio: e?.value ?? null, nomeEnderecomunicipio: e?.label ?? '' })}
                                        loadOptions={(input) => api({
                                            method: 'get',
                                            action: '/municipio',
                                            token,
                                            params: { nome: input }
                                        }).then((response) => (response.data.data ?? []).map((registro) => ({ value: registro.id, label: `${registro.nome}-${registro.uf}` }))).catch(() => [])}
                                    />
                                </FinField>
                                <FinField label="País">
                                    <ReactSelect
                                        value={dados.enderecopais ? { value: dados.enderecopais, label: dados.nomeEnderecopais } : null}
                                        onChange={(e) => setDados({ ...dados, enderecopais: e?.value ?? null, nomeEnderecopais: e?.label ?? '' })}
                                        loadOptions={(input) => api({
                                            method: 'get',
                                            action: '/pais',
                                            token,
                                            params: { nome: input }
                                        }).then((response) => (response.data.data ?? []).map((registro) => ({ value: registro.id, label: registro.nome }))).catch(() => [])}
                                    />
                                </FinField>
                            </div>
                        </div>
                    )}
                </form>
            </div>
        </ErpTemplate>
    );
}
